module.exports = __webpack_public_path__ + "static/media/all-logo.b60a174c.png";